import Main from './Main.vue'

export default [{
  path: 'pregao-leiloeiro-mobile/:id',
  name: 'pregaoleiloeiro-mobile',
  component: Main
}
]



// WEBPACK FOOTER //
// ./src/app/website/pregao-leiloeiro-mobile/routes.js